import {
  PasswordRequirement,
  EmailRequirement,
  PhoneNumberRequirement,
} from '@/_shared/enums/validations';

import {
  ALPHANUMERIC_PATTERN,
  DEFAULT_EMAIL_PATTERN,
  FORBIDDEN_CHARS_PATTERN,
  NUMERIC_PATTERN,
  GUID_PATTERN,
  LETTER_ONLY_PATTERN,
} from '../patterns.constant';
import { ContactUsRequirement } from '@/_shared/enums/validations/contact-us-requirement.enum';

export const PASSWORD_MIN_LENGTH = 8;

export declare type Params = {
  [key: string]: any;
};

export const SUPPORTED_PATTERNS: Record<string, string> = {
  [ALPHANUMERIC_PATTERN]: 'alpha-numeric',
  [DEFAULT_EMAIL_PATTERN]: 'email',
  [FORBIDDEN_CHARS_PATTERN]: 'forbidden-characters',
  [NUMERIC_PATTERN]: 'numeric',
  [GUID_PATTERN]: 'guid',
  [LETTER_ONLY_PATTERN]: 'letters-only',
};

export const PATTERN_ERRORS: Record<string, (fieldName: string) => string> = {
  'alpha-numeric': (fieldName: string) => `${fieldName} must be alpha numeric`,
  'forbidden-characters': (fieldName: string) =>
    `${fieldName} cannot contain forbidden characters`,
  'letters-only': (fieldName: string) => `${fieldName} format is incorrect`,
  numeric: (fieldName: string) => `${fieldName} must be a number`,
  email: (fieldName: string) =>
    fieldName.toLowerCase() === 'email'
      ? 'Input must be a valid email'
      : `${fieldName} must be a valid email`,
  number: (fieldName: string) => `${fieldName} must be a number`,
  guid: (fieldName: string) => `${fieldName} must be a GUID`,
};

export const FIELD_ERROR_MESSAGES: Record<
  string,
  (fieldName: string) => string
> = {
  required: (fieldName) => `${fieldName} is required`,
  numeric: (fieldName) => `${fieldName} must be numeric`,
  email: (fieldName) => `${fieldName} must be a valid email address`,
  [PasswordRequirement.lowerCase]: (fieldName) =>
    `${fieldName} must contain a lowercase letter`,
  [PasswordRequirement.upperCase]: (fieldName) =>
    `${fieldName} must contain an uppercase letter`,
  [PasswordRequirement.number]: (fieldName) =>
    `${fieldName} must contain a number`,
  [PasswordRequirement.specialCharacter]: (fieldName) =>
    `${fieldName} must contain a special character`,
  [PasswordRequirement.length]: (fieldName) =>
    `${fieldName} must contain at least ${PASSWORD_MIN_LENGTH} characters`,
  [EmailRequirement.emailExistsNotAllowed]: (fieldName) =>
    'Email already exists.',
  [EmailRequirement.freeEmailNotAllowed]: (fieldName) =>
    'Cannot register using a free email. Please use your organization email.',
  [EmailRequirement.disposableEmailNotAllowed]: (fieldName) =>
    'Cannot register using a disposable email. Please use your organization email.',
  [PhoneNumberRequirement.invalidNumber]: (fieldName) =>
    `${fieldName} is not a valid phone number.`,
  [PhoneNumberRequirement.invalidCountryCode]: (fieldName) =>
    `${fieldName} has invalid country code.`,
  [PhoneNumberRequirement.tooLong]: (fieldName) => `${fieldName} is too long.`,
  [PhoneNumberRequirement.tooShort]: (fieldName) =>
    `${fieldName} is too short.`,
  [ContactUsRequirement.invalidDetails]: (fieldName) =>
    'Oops! You missed to provide details',
};
